import { ButtonHTMLAttributes } from "react";

import { Timeline } from "antd";
import styled from "styled-components";

import hexToRgb from "shared/utils/hexToRgb";

export const CourseModuleContainer = styled.div`
  & + & > div {
    border-top: none !important;
  }

  .ant-timeline {
    padding: 16px 32px 0px;
    border-top: none !important;
  }
`;

export const CourseModuleContent = styled.div`
  display: flex;
  position: relative;

  padding: 12px 16px 12px 40px;
  color: #535353;
  line-height: 1.3;
  cursor: pointer;

  svg.chevron {
    top: 20px;
    left: 10px;
    position: absolute;
    color: #d9d9d9;
    font-size: 18px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  padding: 20px 0;
`;

interface ICourseLesson extends ButtonHTMLAttributes<HTMLButtonElement> {
  assisted: "true" | "false";
}

export const CourseLesson = styled(Timeline.Item)<ICourseLesson>`
  .ant-timeline-item-head {
    border-color: ${({ theme }) => theme.colors.primary};
    background-color: ${(props) =>
      props.assisted ? props.theme.colors.primary : ""};
  }

  cursor: pointer;

  padding-bottom: 0px !important;

  &:hover {
    color: ${({ theme }) => `rgba(${hexToRgb(theme.colors.primary)}, 0.8)`};
  }

  .lesson-title-container {
    display: flex;
    align-items: center;
  }

  .public-badge {
    display: flex;
    font-size: 12px;
    padding: 3px 6px;
    border-radius: 5px;
    justify-content: center;
    margin-top: 4px;
    margin-left: 8px;
    background: ${({ theme }) => theme.colors.primary};

    color: ${({ theme }) => theme.colors.textMasterColor} !important;
  }
`;
